import { ClipboardLogo } from "@src/appV2/lib";
import { Button } from "@src/appV2/redesign/components/Button";

import { ErrorPageTemplate } from "../Template";

export function NotFoundPage() {
  return (
    <ErrorPageTemplate
      illustration={<ClipboardLogo />}
      title="Page Not Found"
      description="We're sorry, but the page you're looking for doesn't exist."
      actions={
        <Button fullWidth variant="contained" size="large" href="/">
          Browse Shifts
        </Button>
      }
    />
  );
}
